<template>
  <div class="card col-xl-12 col-lg-12">
    <div class="card-header card-header-flex flex-column">
      <a-tabs class="kit-tabs" v-model="activeKey" @change="onTabChange">
        <a-tab-pane key="types" :tab="$t('comptabilite.tabDepenseTypes')" />
        <a-tab-pane key="companies" :tab="$t('comptabilite.tabCompanies')" />
        <a-tab-pane
          key="categories"
          :tab="$t('comptabilite.tabDepenseCategories')"
        />
        <a-tab-pane
          key="subcategories"
          :tab="$t('comptabilite.tabDepenseSubcategories')"
        />
        <a-tab-pane key="associates" :tab="$t('comptabilite.tabAssociates')" />
        <a-tab-pane key="unites" :tab="$t('comptabilite.tabUnites')" />
        <a-tab-pane key="debiteurs" :tab="$t('comptabilite.tabDebiteurs')" />
        <a-tab-pane
          key="documentDisplay"
          :tab="$t('comptabilite.tabDocumentDisplay')"
        />
      </a-tabs>
    </div>
    <div class="card-body">
      <component :is="currentTabComponent" :key="activeKey" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import CompaniesTab from "./components/CompaniesTab.vue";
import TypesTab from "./components/TypesTab.vue";
import CategoriesTab from "./components/CategoriesTab.vue";
import SubCategoriesTab from "./components/SubCategoriesTab.vue";
import AssociatesTab from "./components/AssociatesTab.vue";
import UnitesTab from "./components/UnitesTab.vue";
import DebiteursTab from "./components/DebiteursTab.vue";
import DocumentDisplayTab from "./components/DocumentDisplayTab.vue";

const TAB_COMPONENTS = {
  companies: "CompaniesTab",
  types: "TypesTab",
  categories: "CategoriesTab",
  subcategories: "SubCategoriesTab",
  associates: "AssociatesTab",
  unites: "UnitesTab",
  debiteurs: "DebiteursTab",
  documentDisplay: "DocumentDisplayTab",
};

export default {
  name: "compatibilite",
  components: {
    CompaniesTab,
    TypesTab,
    CategoriesTab,
    SubCategoriesTab,
    AssociatesTab,
    UnitesTab,
    DebiteursTab,
    DocumentDisplayTab,
  },
  data() {
    return {
      activeKey: "types",
    };
  },
  computed: {
    currentTabComponent() {
      return TAB_COMPONENTS[this.activeKey] || "TypesTab";
    },
  },
  methods: {
    onTabChange(key) {
      this.activeKey = key;
      this.$gtag.pageview({
        page_path: this.$route.path,
        page_location: window.location.href,
        page_title:
          document.title + " - " + (TAB_COMPONENTS[key] || "comptabilite"),
      });
    },
  },
};
</script>
